import { render, staticRenderFns } from "./OrderLists.vue?vue&type=template&id=6b7036d9&scoped=true&"
import script from "./OrderLists.vue?vue&type=script&lang=js&"
export * from "./OrderLists.vue?vue&type=script&lang=js&"
import style0 from "./OrderLists.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OrderLists.vue?vue&type=style&index=1&id=6b7036d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7036d9",
  null
  
)

export default component.exports